import "./style.css"
import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const StepMarker = ({ current, selected, completed = false, icon, text, callback = () => { } }) => {
    let className = "step-marker " + (completed ? " completed " : "") + (selected ? " selected " : "") + (current ? " current " : "");
    return <div className={className}>
        <div className="step-marker-icon" onClick={callback}>
            <div><FontAwesomeIcon icon={icon} /></div>
        </div>
        <div className="step-marker-text">{text}</div>
    </div>
}

export default StepMarker